import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FaqsComponent } from '../../../../widgets/faqs/faqs.component';
import { FaqItem } from '../../../../core/interface/faq.modal';

@Component({
  selector: 'app-cloud-monitoring-solutions',
  imports: [CommonModule, RouterModule, FeatureHero, FaqsComponent],
  templateUrl: './cloud-monitoring-solutions.html',
  styleUrl: './cloud-monitoring-solutions.scss',
})
export class CloudMonitoringSolutions {
  faqs: FaqItem[] = [
    {
      question: 'What is cloud-based IT monitoring?',
      answer: {
        paragraphs: ['Cloud-based IT monitoring is the virtualized process of tracking and analyzing the end-to-end IT infrastructure of an enterprise. This includes applications, databases, servers, ports, websites, and any other part of the infrastructure that business operations are dependent on. It also involves ensuring that relevant teams have access to cloud-based tools to achieve 24x7 IT monitoring.']
      }
    },
    {
      question: 'Why do enterprises of all sizes need cloud monitoring software?',
      answer: {
        paragraphs: ['Cloud monitoring solutions empower enterprises to gain control of their complete IT infrastructure – getting a 360-degree view into everything that needs to be monitored and measured. No matter their size, enterprises can identify mission-critical IT metrics that affect business performance. Since it is delivered as a single solution offering, they can also consolidate large volumes of data from disparate sources and provide a golden record of meaningful performance insights.']
      }
    },
    {
      question: 'What are the primary advantages of cloud monitoring tools?',
      answer: {
        paragraphs: ["Some of the advantages of cloud-based IT monitoring solutions like Infraon ITIM are:"],
        list: {
          type: 'ul',
          items: [
            "Remote IT Management: Cloud-driven IT monitoring tools enable remote 24x7x365 management of IT infrastructure like apps, servers, ports, and websites to ensure agile business continuity.",
            "Quick Deployment & Integration: Cloud IT monitoring is a ready-to-deploy solution that comes equipped with pre-built workflows, accelerators, and rules to get started as soon as possible.",
            "Easy to Maintain: An effective cloud IT monitoring system comes without additional maintenance tasks or overheads as the vendor takes ownership of it.",
            "Scalability & Reliability: Cloud-based tools ensure that enterprises can reliably scale up monitoring efforts based on the pace of business growth without experiencing unforeseen outages.It includes monitoring both private and public cloud, such as AWS, Azure, Google, to name a few."
          ]
        }
      }
    },
    {
      question: 'What are some examples of cloud-based IT monitoring features?',
      answer: {
        paragraphs: ["Some of these cloud-driven features include IT Infrastructure Monitoring, Event Monitoring, Port Monitoring, Problem Monitoring, Fault Monitoring, Incident Monitoring, Request Monitoring, Change Monitoring, API Monitoring, SLA Monitoring, Website & URL Monitoring, etc."]
      }
    },
    {
      question: 'What are the questions to ask while selecting a cloud-based IT monitoring solution?',
      answer: {
        list: {
          type: 'ul',
          items: [
            "Is there an integrated incident/fault management system to avoid using multiple tools?",
            "Does it have inbuilt policies to guarantee data security, compliance, and governance?",
            "Are there too many service dependencies that would slow down your solution usage?",
            "Does it come with complicated contracts and SLAs that may lead to vendor lock-in?"
          ]
        }
      }
    }
  ];
}
